import { useEffect } from "react";
import { Header } from "../components/layout/Header";
import { Footer } from "../components/layout/Footer";
import { Hero } from "../components/home/Hero";
import { Welcome } from "../components/home/Welcome";
import { Services } from "../components/home/Services";
import { Meadow } from "../components/home/Meadow";
import { Details } from "../components/home/Details";
import { Steps } from "../components/home/Steps";
import { Reviews } from "../components/home/Reviews";
import { GalleryStrip } from "../components/home/GalleryStrip";
import { FinalCta } from "../components/home/FinalCta";

export default function HomePage() {
  useEffect(() => {
    document.title = "Mary Pawpins Pet Care | Inverness Dog Walking & Pet Sitting";
  }, []);
  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Welcome />
        <Services />
        <Meadow />
        <Details />
        <Steps />
        <Reviews />
        <GalleryStrip />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
